import React, { Fragment, useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const SkltnTicketItem = () => {

    const [state, setState] = useState([1, 2, 3, 4, 5, 6, 7, , 8, 9, 10, 11, 12, 13, 14, 15])

    return (
        <Fragment>
            {state.map((info, index) =>
                <div className="ticketItem" key={index}>
                    <div className="number">
                        <Skeleton animation="wave" width={40} height={30} />
                    </div>
                    <div className="ttl">
                        <Skeleton animation="wave" width={250} height={30} />
                    </div>
                    <div className="date">
                        <Skeleton animation="wave" width={90} height={30} />
                    </div>
                    <div className={`status`}>
                        <Skeleton animation="wave" width={90} height={30} />
                    </div>
                </div>
            )}
        </Fragment>
    )
}

export default SkltnTicketItem;